
import React from 'react';
import {
  Grid,
} from "@mui/material";
import Rating from '../Ratings/index'
import National from '../National/National';
import AddressDetails from '../AddressDetails/Address';
import Homeownerformimage from '../Homeownerformimage';

const Homeownersection = (props) => {
  const { name, item } = props;
  return (
    <Grid style={{ boxShadow: 8, backgroundColor: '#FCFCFC' }}>
      {/* <SectionHomeowner data={item} name={name} /> */}
      <Homeownerformimage data={item} name={name}></Homeownerformimage>
      <National heading={'National ID'} Subheading={'ID number '} ID={"00 11 22 22 44 55"} />
      <AddressDetails />
      <Rating name={name} />
    </Grid>
  )
}
export default Homeownersection;












